import { PlusProduct } from './entities';
import { ListenableSubscribable } from '@benzinga/subscribable';
import { arrayDifference } from '@benzinga/utils';

interface PlusProductsUpdateEvent {
  type: 'plus:updated_plus_products';
  products: PlusProduct[];
}

export type PlusStoreEvent = PlusProductsUpdateEvent;

export class PlusStore extends ListenableSubscribable<PlusStoreEvent> {
  private date?: Date;
  private products?: PlusProduct[];

  constructor() {
    super();
    this.date = undefined;
    this.products = undefined;
  }

  public static comparePlusProducts = (lhs: PlusProduct[], rhs: PlusProduct[]): boolean => {
    return arrayDifference(lhs, rhs).length === 0;
  };

  public shouldWeFetchProduct = (): boolean => {
    const ONE_MIN = 60 * 1000; /* ms */
    const lastCalled = this.date?.getTime() ?? 0; // use this once all watchlist are grabbed from manager
    if (this.products === undefined || Date.now() - lastCalled > ONE_MIN) {
      return true;
    }
    return false;
  };

  public getProducts = (): PlusProduct[] | undefined => {
    return this.products;
  };

  // returns true if update was committed
  public updateProducts = (products: PlusProduct[]): boolean => {
    this.date = new Date();
    if (this.products && PlusStore.comparePlusProducts(this.products, products)) {
      return false;
    } else {
      this.products = products;
      this.dispatch({
        products,
        type: 'plus:updated_plus_products',
      });
      return true;
    }
  };

  public getPlusProductsForce = (): PlusProduct[] => {
    return this.products ? [...this.products] : [];
  };
}
